// 所有API地址

export function interfaceUrl(key){

	var apis = [];

	//登录
	apis['LOGIN'] = 'api/auth/login';

	// 用户资源[ID]
	apis['USER_BY_ID'] = 'api/account/profile';

	// 获取公告列表
	apis['BULLETIN_ALL'] = 'api/notice/list?page=$&per_page=10&sort=-is_top,-sendtime';

	// 获取公告详情
	apis['BULLETIN_DETAIL'] = 'api/notice/$';

	// 获取活动列表
	apis['GET_ACTIVITY_LIST'] = 'api/activity/list';

	// 获取BANNER列表
	apis['BANNER_ALL'] = 'api/ads/$/banners?limit=20';

	// 获取彩票销售情况
	apis['LOTTERY_SALEINFO'] = 'api/lottery/sale-info'

	// 获取游戏列表
	apis['GET_GAMELIST'] = 'api/game/all';

	// 获取中奖人名单
	apis['WINNER_ALL'] = 'api/user/winners';

	// 获取玩法动态信息
	apis['DYNAMIC_METHOD_INFO'] = 'api/lottery/user-methods';

	// 获取静态玩法信息
	apis['GET_STATIC_METHOD_INFO'] = 'api/lottery/$/method-menus';

	// 获取动态用户菜单
	apis['GET_USER_MENUS'] = 'api/account/menus';

	// 获取当前彩种信息
	apis['GET_CURRENT_ISSUE'] = 'api/lottery/$/current-issue';

	// 获取推送服务器信息
	apis['GET_PUSH_SERVICE_INFO'] = 'api/push/settings';

	// 获取验证码
	apis['GET_VALIDCODE'] = 'api/captcha'

	// 获取彩种可追奖期
	apis['GET_TRACK_ISSUES'] = 'api/lottery/$/tracking-issues?limit=$'

	// 投注
	apis['LOTTERY_BET'] = 'api/lottery/bet'

	// 秒秒彩投注
	apis['LOTTERY_MMC_BET'] = 'api/lottery/mmc/bet'

	// 根据彩种ID获取历史开奖奖期, MMC近期开奖
	apis['GET_LOTTERY_HISTORY'] = 'api/lottery/$/bonus-numbers?limit=$';

	// 获取用户最近投注注单
	apis['GET_USER_BET_RECENT'] = 'api/lottery/projects'

	// 使用新版TOKEN换取旧版SESSION
	apis['GET_SESSION_BY_TOKEN'] = 'api/auth/sessid?client_id=$';

	// 使用老版SESSION换取新版TOKEN
	apis['GET_TOKEN_BY_SESSION'] = 'api/auth/token?sessid=$';

	// 获取游戏分类列表
	apis['GET_GAME_CATEGORIES'] = 'api/game/categories?limit=50';

	// 获取当前页的游戏列表
	apis['GET_GAME_LIST'] = 'api/game/list?per_page=$&platform_id=$&cate_id=$&page=$'

	// 获取热门游戏
	apis['GET_HOTGAME'] = 'api/game/list?per_page=50&platform_id=$&is_hot=1';

	// 获取上一期开奖信息
	apis['GET_LAST_ISSUE'] = 'api/lottery/$/last-issue';

	// 模拟开奖
	apis['SIMULATED_NUMBER'] = 'api/lottery/$/simulated-number';

	// 获取彩种有效号码
	apis['GET_VALID_NUMBER'] = 'api/lottery/$/valid-number';

	// 获取未读聊天条数
	apis['GET_UNREAD_CHAT_COUNT'] = 'api/chat/unread'

	// 获取平台余额
	apis['GET_BALANCE_FROM_PLATFORM'] = 'api/game/balance/$';

	// 获取彩票余额
	apis['GET_BALANCE_FOR_LOTTERY'] = 'api/account/balance/lottery';

	// 平台间转账
	apis['TRANSFER_BALANCE'] = 'api/game/transfer';

	// 修改密码
	apis['CHANGE_PASSWORD'] = 'api/account/password';

	// 修改提款密码
	apis['CHANGE_WITHDRAWAL_PASSWORD'] = 'api/account/security-password';

	// 创建平台账号
	apis['CREATE_PLATFORM_ACCOUNT'] = 'api/game/$/account';

	// 修改平台密码
	apis['MODIFY_PLATFORM_PASSWORD'] = 'api/game/$/password';

	// 域名测速
	apis['GET_SPEEDTEST_URLS'] = 'api/domain/speedtests?limit=20';

	// 域名验证
	apis['GET_CHECK_URLS'] = 'api/domain/$/verification?validcode=$';

	// 获取环境变量，系统设置
	apis['GET_WEB_SETTINGS'] = 'api/settings/?fields=$';

	// 获取平台用户名等信息
	apis['GET_PLATFORM_PROFILE'] = 'api/game/$/profile';

	// 获取平台开始游戏地址
	apis['GET_PLATFORM_PLAYURL'] = 'api/game/$/playurl';

	// 设置、修改密保问题
	apis['SET_SECURITY_QUESTIONS'] = 'api/account/security-questions';

	// 获取站内信
	apis['GET_MESSAGES'] = 'api/message/list?page=$'

	// 单个站内信操作
	apis['MESSAGES_ACTION'] = 'api/message/$'

	// 获取收藏列表
	apis['FAVORITES_LIST'] = 'api/favorites/list?limit=$&type=$&sort=$'

	// 批量添加收藏
	apis['FAVORITES_CREATE'] = 'api/favorites/$'

	// 批量删除收藏
	apis['FAVORITES_DELETE'] = 'api/favorites'

	// 登出
	apis['LOGOUT'] = 'api/auth/logout'

	// 获取不推荐彩种，此接口用于弹出提示框，当用户在非推荐彩种时弹出
	apis['GET_PREVENT_LOTTERYS'] = 'api/lottery/push'

	apis['GET_WITHDRAWAL_LIST_USDT'] = 'api/digitalcurrency/listwithdraw?checkcode=$';

	apis['CHECK_WITHDRAWAL_DATA_USDT'] = 'api/digitalcurrency/verifywithdraw';

	apis['WITHDRAWAL_USDT'] = 'api/digitalcurrency/withdraw';

	apis['GET_WALLET_LIST'] = 'api/digitalcurrency/list?checkcode=$';

	apis['LOCK_WALLET'] = 'api/digitalcurrency/lock';

	apis['CHECK_REBIND'] = 'api/digitalcurrency/verifyrebinding';

	apis['MODIFY_WALLET_ADDRESS'] = 'api/digitalcurrency/rebinding';

	apis['BIND_NEW_WALLET'] = 'api/digitalcurrency/add';

	apis['BIND_NEW_WALLET'] = 'api/digitalcurrency/add';

	apis['CHECK_LAST_BIND'] = 'api/digitalcurrency/checklast';

	apis['CHECK_USDT_AVAILABLE'] = 'api/digitalcurrency/isenable';

	apis['GET_COIN_TYPE_LIST'] = 'api/digitalcurrency/cointype';

	apis['LEGAL_WITHDRAW_TYPE'] = 'api/digitalcurrency/legalwithdrawtype';

	//获取安全钱包转账信息
	apis['GET_SAFTYWALLET_INFO'] ='api/saftywallet/wallettransfer?transfertype=$';

	//安全钱包转账确认
	apis['CHECK_SAFTYWALLEY_TRANSFERPOST']='api/saftywallet/wallettransferpost';
		
	//获取用户是否支持安全钱包提款
	apis['SAFTYWALLET_SUPPORT']='api/saftywallet/isenable';
	
	//获取安全钱包提款信息
	apis['GET_SAFTYWALLEY_WITHDRAWAL'] ='api/saftywallet/getwalletwithraw?checkcode=$';
	
	//安全钱包提款信息确认
	apis['CONFIRM_SAFTYWALLET_INFO'] ='api/saftywallet/postwalletwithraw';
	
	//提交安全钱包提款
	apis['SBUMIT_SAFTYWALLET_INFP']= 'api/saftywallet/verifywalletwithraw';

	// 获取广告合集
	apis['GET_ADS']= 'api/ads/recommend'
	
	return apis[key];

}
